import DOMPurify from 'dompurify'

/**
 * Sanitizer for CMS-authored HTML (course materials, overviews, pages, bios).
 *
 * DOMPurify drops the `target` attribute by default, which silently undid the
 * "open in new window" setting editors choose in CKEditor. We allow `target`
 * back in and, for `_blank` links, force `rel="noopener noreferrer"` so the
 * opened page cannot reach back into ours via window.opener.
 */
const CONFIG = { ADD_ATTR: ['target'] }

DOMPurify.addHook('afterSanitizeAttributes', node => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank')
    node.setAttribute('rel', 'noopener noreferrer')
})

export const sanitizeHtml = html => DOMPurify.sanitize(html || '', CONFIG)

export default sanitizeHtml
